import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest, setToken} from '../generalRequest';

const initialState = {
    isLoading: false,
    isLoginSuccessful: false,
    token: '',
    accountType: '',
    shouldRedirectToPasswordReset: false,
    shouldDisplayTermsAndConditionsPopUp: false,
    termsAndConditionsId: '',
    termsAndConditionsURL: '',
    shouldDisplayTwoFactorAuth: false,
    loginMessage: '',
    isOtpSuccessfullyResent: false,
    shouldRedirectToPhoneValidation: false,
    shouldRedirectToEmailValidation: false,
    shouldRedirectToIndividualOrExpressStep: false,
    phone: '',
    shouldDisplayIdCardUpload: false,
    accountType: '',
    prefix: '',
    scaToken: '',
    registeredDevices: '',
    showLoggedDevices: false,
    isManualRegistration: false,
    clientData: '',
    shouldRedirectToFifthStep: false,
    loginWhenFacephiDone: false,
    hasPinBeenRegistered: true
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers:
    {
        setIsLoading : (state, action) => {
            state.isLoading = action.payload
        },
        setShouldDisplayTermsAndConditionsPopUp : (state, action) => {
            state.shouldDisplayTermsAndConditionsPopUp = action.payload
        },
        setShouldDisplayIdCardUpload : (state, action) => {
            state.shouldDisplayIdCardUpload = action.payload
        },
        setShouldRedirectToPhoneValidation : (state, action) => {
            state.shouldRedirectToPhoneValidation = action.payload
        },
        setShouldRedirectToIndividualOrExpressStep : (state, action) => {
            state.shouldRedirectToIndividualOrExpressStep = action.payload
        },
        setShouldRedirectToEmailValidation : (state, action) => {
            state.shouldRedirectToEmailValidation = action.payload
        },
        setShouldRedirectToPasswordReset : (state, action) => {
            state.shouldRedirectToPasswordReset = action.payload
        },
        setShouldDisplayTwoFactorAuth : (state,action) => {
            state.shouldDisplayTwoFactorAuth = action.payload
        },
        setIsOtpSuccessfullyResent : (state,action) => {
            state.isOtpSuccessfullyResent = action.payload
        },
        resetLoginMessage : (state) => {
            state.loginMessage = ''
        },
        showLoggedDevicesDialog : (state, action) => {
            state.showLoggedDevices = action.payload
        },
        setIsManualRegistration: (state, action) => { 
            state.isManualRegistration = action.payload
        },
        setShouldRedirectToFifthStep : (state, action) => {
            state.shouldRedirectToFifthStep = action.payload
        },
        setLoginWhenFacephiDone : (state, action) => {
            state.loginWhenFacephiDone = action.payload
        },
        setHasPinBeenRegistered: (state, action) => 
        {
            state.hasPinBeenRegistered = action.payload
        },
        resetLoginState: () => initialState 
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            })
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                state.accountType = action.payload.response.accountType 

                if(action.payload.endpoint === 'NewFlowLogin')
                {        
                    state.isManualRegistration = action.payload.response.isManualRegistration 
                    if(action.payload.response.code === 0)
                    {
                        state.isLoginSuccessful = true
                        state.token = action.payload.response.token 
                        state.accountType = action.payload.response.accountType 
                        state.shouldDisplayTwoFactorAuth = true
                    }
                    else if(action.payload.response.code === 7)
                    {
                        state.loginMessage = action.payload.response.errorMsg
                        state.shouldRedirectToPasswordReset = true
                    } 
                    else if(action.payload.response.code === 9)
                    {
                        state.loginMessage = action.payload.response.errorMsg
                        //state.token = action.payload.response.token
                    }
                    else if(action.payload.response.code === 10)
                    {
                        state.accountType = action.payload.response.accountType
                        state.loginMessage = action.payload.response.errorMsg
                        state.token = action.payload.response.token
                        state.isManualRegistration = action.payload.response.isManualRegistration
                        state.shouldRedirectToIndividualOrExpressStep = true
                    }
                    else if(action.payload.response.code === 12 || action.payload.response.code === 13)
                    {
                        state.phone = action.payload.response.phone
                        state.token = action.payload.response.token
                        state.accountType = action.payload.response.accountType
                        state.shouldRedirectToPhoneValidation = true
                        state.loginMessage = action.payload.response.errorMsg
                        state.prefix = action.payload.response.prefix
                    }
                    else if(action.payload.response.code === 15)
                    {
                        state.token = action.payload.response.token
                        state.shouldRedirectToEmailValidation = true
                        state.loginMessage = action.payload.response.errorMsg
                    }          
                    else if(action.payload.response.code === 16) 
                    {
                        state.shouldDisplayTermsAndConditionsPopUp = true
                        state.termsAndConditionsId = action.payload.response.listOfTC[0].idTC
                        //state.termsAndConditionsURL = action.payload.response.URL
                        state.termsAndConditionsURL = action.payload.response.listOfTC[0].URL
                        state.accountType = action.payload.response.accountType
                        state.token = action.payload.response.token
                    }
                    else if(action.payload.response.code === 17)
                    {
                        state.shouldDisplayIdCardUpload = true
                        state.token = action.payload.response.token
                    }
                    else if(action.payload.response.code === 18)
                    {
                        state.shouldDisplayTwoFactorAuth = true
                        state.token = action.payload.response.token
                        state.accountType = action.payload.response.accountType
                    }     
                    else if(action.payload.response.code === 19) 
                    {
                        if(action.payload.response.listOfTC.length > 0){
                            state.shouldDisplayTermsAndConditionsPopUp = true
                            state.accountType = action.payload.response.accountType 
                            state.termsAndConditionsId = action.payload.response.listOfTC[0].idTC
                            state.termsAndConditionsURL = action.payload.response.listOfTC[0].URL
                        }
                        state.token = action.payload.response.token
                        state.scaToken = action.payload.response.token
                        state.accountType = action.payload.response.accountType 
                        state.registeredDevices = action.payload.response.registeredDevices
                        state.showLoggedDevices = true
                    }
                    else if(action.payload.response.code === 20)
                    {
                        if(action.payload.response.clientData !== null) {
                            state.token = action.payload.response.token
                            state.clientData = action.payload.response.clientData
                            state.shouldRedirectToFifthStep = true
                            state.accountType = action.payload.response.accountType
                        }
                    }                
                    else if(action.payload.response.code === 22)
                    {
                        if(action.payload.response.clientData !== null) {
                            state.token = action.payload.response.token
                            state.clientData = action.payload.response.clientData
                            state.shouldRedirectToFifthStep = true
                            state.accountType = action.payload.response.accountType
                        }
                    }                
                }
                else if(action.payload.endpoint === 'AcceptTermsAndConditions')
                {
                    //state.isLoginSuccessful = true
                    state.shouldDisplayTermsAndConditionsPopUp = false
                }
                else if(action.payload.endpoint === 'ValidateOtpGeneric')
                {
                    state.isLoginSuccessful = true
                }
                else if(action.payload.endpoint === 'ResendOtpGeneric')
                {
                    state.isOtpSuccessfullyResent = true
                    state.responseMessage = action.payload.response.errorMsg
                    state.success = action.payload.response.success
                }        
            })
            
    },
})
export const { setShouldDisplayTermsAndConditionsPopUp, setIsLoading,setShouldRedirectToIndividualOrExpressStep, setShouldDisplayIdCardUpload, setShouldRedirectToPasswordReset,setShouldDisplayTwoFactorAuth, resetLoginMessage,setShouldRedirectToPhoneValidation,setShouldRedirectToEmailValidation, setIsOtpSuccessfullyResent, setIsLoginSuccessfull, resetLoginState, setIsManualRegistration, setShouldRedirectToFifthStep, setLoginWhenFacephiDone, showLoggedDevicesDialog, setHasPinBeenRegistered} = loginSlice.actions;

export const selectLoginState = (state) => state.login;

export default loginSlice.reducer;

